export const APP_PATH = {
  // Imaging Authentication
  login: "/api/v1/imaging/auth/login",
  refreshToken: "/api/v1/imaging/auth/refresh-token",
  logout: "/api/v1/imaging/auth/logout",
  validateToken: "/api/v1/auth/validate-token",

  // Imaging-specific endpoints
  getConsultation: "/api/v1/consultation/me",
  getDocument: "/api/v1/consultation/documents/my-documents",
  forgotPassword: "/api/v1/consultation/forgot-password",
  resetPassword: "/api/v1/consultation/reset-password",

  // Imaging Forgot Password (OTP flow)
  forgotPasswordSendOtp: "/api/v1/imaging/forgot-password/send-otp",
  forgotPasswordVerifyOtp: "/api/v1/imaging/forgot-password/verify-otp",
  forgotPasswordReset: "/api/v1/imaging/forgot-password/reset",
  changePassword: "/api/v1/imaging/change-password",
  uploadAvatar: "/api/v1/media/upload-avatar",

  // Patient endpoints (if needed for imaging operations)
  verifyOtp: "/api/v1/auth/patient/verify-otp",
  resendOtp: "/api/v1/auth/patient/resend-otp",
  getPatientDetails: "/api/v1/consultation/patient/details",
  // Lightweight chat participant lookup (name + presigned avatar by user id) —
  // used by the global ChatDock header on any screen (incl. general chats).
  chatParticipant: "/api/v1/consultation/chat/participant",

  // Notifications
  getUserNotifications: "/api/v1/notification/user",
  markNotificationRead: "/api/v1/notification",
  deleteNotification: "/api/v1/notification",
  getUnreadNotificationCount: "/api/v1/notification/unread-count",
  markAllNotificationsRead: "/api/v1/notification/mark-all-read",

  // Insurance endpoints (for imaging claims)
  insuranceLogin: "/api/v1/insurance/login",
  insurancelogout: "/api/v1/insurance/logout",
  medicalOrders: "/api/v1/insurance/claims/medical-orders",
  labTests: "/api/v1/insurance/claims/lab-tests",
  statistics: "/api/v1/insurance/claims/statistics",
  history: "/api/v1/insurance/claims/history",
  claims: "/api/v1/insurance/claims/{claimId}",
  verify: "/api/v1/insurance/claims/{claimId}/verify",
  claimsReject: "/api/v1/insurance/claims/{claimId}/reject",
  claimsApproveItem: "/api/v1/insurance/claims/{claimId}/approve-item",
  claimsRejectItem: "/api/v1/insurance/claims/{claimId}/reject-item",
  claimsCalculate: "/api/v1/insurance/claims/{claimId}/calculate",
  claimsinvoice: "/api/v1/insurance/claims/{claimId}/invoice",
  claimsexport: "/api/v1/insurance/claims/export",
  claimsdocuments: "/api/v1/insurance/claims/{claimId}/documents",

  // Pharmacy endpoints (if needed for imaging operations)
  getPharmacyOrders: "/api/v1/pharmacy/orders",
  confirmPharmacyOrder: "/api/v1/pharmacy/orders",
  searchPharmacyMedicines: "/api/v1/pharmacy/medicines/search",

  // Imaging Orders endpoints
  getImagingOrders: "/api/v1/imaging/orders",
  imagingOrders: "/api/v1/imaging/orders",
  exportImagingOrders: "/api/v1/imaging/orders/export",
  addOrderTests: "/api/v1/imaging/orders", // For POST /:id/tests
  uploadResults: "/api/v1/imaging/orders", // For POST /:id/upload-results
  uploadResultsMultipart: "/api/v1/imaging/orders", // For POST /:id/upload-results-multipart
  uploadMultipleResults: "/api/v1/imaging/orders", // For POST /:id/upload-multiple-results
  getFilePresignedUrl: "/api/v1/imaging/orders", // For GET /:id/file/:fileId/presigned-url
  deleteTestResultFile: "/api/v1/imaging/orders", // For DELETE /:id/file/:fileId
  imagingResultLink: "/api/v1/imaging/orders", // For POST / DELETE /:id/result-link
  imagingResendReport: "/api/v1/imaging/reports", // For POST /:id/resend

  // Imaging Reports endpoints
  getImagingReports: "/api/v1/imaging/reports", // For GET /
  getReportDetails: "/api/v1/imaging/reports", // For GET /:id
  resendReport: "/api/v1/imaging/reports", // For POST /:id/resend

  // Imaging Services endpoints (for managing test catalog)
  imagingServices: "/api/v1/imaging/services",
  imagingServiceCategories: "/api/v1/imaging/services/categories",

  // Imaging Technicians endpoints
  imagingTechnicians: "/api/v1/imaging/technicians",

  // Imaging Earnings endpoints
  imagingEarningsSummary: "/api/v1/imaging/earnings/summary",
  imagingEarnings: "/api/v1/imaging/earnings",
  imagingEarningsExport: "/api/v1/imaging/earnings/export",

  // Imaging Orders Dashboard endpoints
  imagingOrdersPending: "/api/v1/imaging/orders/pending",
  imagingOrdersOngoing: "/api/v1/imaging/orders/ongoing",
  imagingOrdersMetrics: "/api/v1/imaging/orders/metrics/dashboard",

  // Admin-configured reject-order reasons for this center (dropdown on the
  // Reject Order dialog). Requires ?service_type=imaging
  providerRejectionReasons: "/api/v1/provider/rejection-reasons",

  // Imaging Profile endpoints
  imagingProfile: "/api/v1/imaging/profile",
  imagingAddresses: "/api/v1/imaging/addresses",

  // Regions catalog (governorate-level)
  regions: "/api/v1/auth/regions",

  // Chat with Admin
  consultationChatMessages: "/api/v1/consultation/chat/messages",
  consultationChatMarkRead: "/api/v1/consultation/chat/mark-read",
  consultationChatUnreadCount: "/api/v1/consultation/chat/unread-count",
  consultationChatRooms: "/api/v1/consultation/chat/rooms",
  consultationChatUpload: "/api/v1/consultation/chat/upload",
  consultationChatDownload: "/api/v1/consultation/chat/download",

  // Public endpoints (no authentication required)
  publicOrderDetails: "/api/v1/public/imaging/orders",
  publicAppointmentDetails: "/api/v1/public/appointments",
  publicAppointmentWorkflow: "/api/v1/public/appointments",

  // Settlement / Payout Account (payment-service) — generic provider endpoints
  submitSettlementRequest: "/api/v1/payment/settlements/request",
  getProviderSettlements: "/api/v1/payment/settlements",
  getSettlementDashboard: "/api/v1/payment/settlements/dashboard",
  payoutAccounts: "/api/v1/payment/payout-accounts",
  getDefaultPayoutAccount: "/api/v1/payment/payout-accounts/default",
};
